import domReady from './utils/domReady'
import navigation from './universal/navigation-desktop'
import navigationMobile from './universal/navigation-mobile'
import search from './universal/search'

// Blocks
import setActive from './utils/setActive'
import playVideo from './sections/video'


domReady(ev => {
    navigation()
    navigationMobile()
    search()
    playVideo()
})